import React, { useEffect, useState } from "react";
import renderInput from "helpers/FormGenerator";
import AdminLayout from "components/MainApp/layouts/DesktopLayout";

import styles from "./MainApp.organisms.Tags.TagAssociationModal.module.scss";
import FilterPanel from "../../Filters/FilterPanel";
import SimpleSearchPanel from "../../Filters/SimpleSearchPanel";
import useFilters from "hooks/useFilters";
import AssociationProductFilter from "./AssociationProductFilter";
import { useHistory } from "react-router";
import useRequest from "hooks/useRequest";
import { PublicService } from "services/PublicService";
import { StockService } from "services/StockService";
import LocalizationProductItem from "shared/components/LocalizationProductItem";
import AssociationProductItem from "shared/components/AssociationProductItem";
import { ProductService } from "services/ProductService";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

export const TagAssociationModal = ({
  fields,
  handleClose,
  handleSelect,
  handleAssociateTag
}) => {
  const [itemId, setItemId] = useState(null);

  const [product, setProduct] = useState(null);
  const { loading, afterSubmit } = useRequest();

  const handleSelectedItem = item => {

    if (item && item.key) {
      ProductService.product(item.key).then(
        response => {
          setProduct(response);
          handleSelect(response);
        },
        error => {
          setProduct(null);
          handleSelect(null);
        }
      );
    } else {
      setProduct(null);
      handleSelect(null);
    }
  };

  const content = (
    <div className={styles["location-modal-content-wrapper"]}>
      <div className={styles["location-modal-content"]}>
        <AssociationProductFilter handleApply={handleSelectedItem} />
        {product && <AssociationProductItem product={product} />}
      </div>
      <div className={styles["load-movement-items-buttons-wrapper"]}>
        <div
          className={`${styles["load-movement-items-button"]} ${product ? "" : styles["disabled"]}`}
          onClick={handleAssociateTag}
        >
          {i18n.t("associate")}
        </div>
      </div>
    </div>
  );
  return (
    <div className={styles["location-modal-container"]}>
      <AdminLayout
        headerTitle={capitalize(i18n.t("associate.with.product").toLowerCase())}
        headerOptions={[]}
        content={content}
        closeFunc={handleClose}
        navHidden={true}
      ></AdminLayout>
    </div>
  );
};

export default TagAssociationModal;
